import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, ZapIcon, FileTextIcon } from 'lucide-react';
import { CountdownUrgency } from './CountdownUrgency';
import { goToCheckout } from '../lib/checkout';
const ORDER_ITEMS = ['6-volume player health, performance, and mental game system', 'Bonus 1 — Shooting Checklist', 'Bonus 2 — Injury Risk Guide', 'Bonus 3 — Pressure Routine for Free Throws', 'Bonus 4 — Young Athlete Guide', 'Bonus 5 — 12-Week Progression Tracker'];
export function PurchaseSection() {
  return <section id="purchase" className="scroll-mt-4" data-id="element-133">
      <div className="rounded-2xl border-2 border-orange-500 bg-neutral-900/90 p-5 shadow-[0_0_40px_rgba(249,115,22,0.25)] backdrop-blur-sm" data-id="element-134">
        <div className="mb-4 text-center" data-id="element-135">
          <span className="inline-block rounded-full bg-orange-500 px-3 py-1 text-[11px] font-extrabold uppercase tracking-wider text-black" data-id="element-136">
            Limited-Time Offer
          </span>
          <h2 className="mt-3 font-display text-2xl uppercase text-white" data-id="element-137">
            Your Complete Coaching System
          </h2>
        </div>

        {/* Urgency */}
        <CountdownUrgency data-id="element-138" />

        {/* Order summary */}
        <div className="mt-4 rounded-xl border border-neutral-700 bg-black/40 p-4" data-id="element-139">
          <p className="mb-3 text-xs font-bold uppercase tracking-wider text-orange-400" data-id="element-140">
            Order Summary
          </p>
          <ul className="space-y-2" data-id="element-141">
            {ORDER_ITEMS.map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-neutral-200" data-id="element-142">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-orange-400" data-id="element-143" />
                <span data-id="element-144">{item}</span>
              </li>)}
          </ul>

          <div className="mt-3 rounded-lg bg-orange-500/10 px-3 py-2 text-center" data-id="element-145">
            <p className="text-xs font-bold text-orange-300" data-id="element-146">
              🎁 All 5 bonuses are FREE today only
            </p>
          </div>
        </div>

        {/* Price */}
        <div className="mt-5 text-center" data-id="element-147">
          <p className="text-sm text-neutral-400" data-id="element-148">
            Regular price:{' '}
            <span className="line-through decoration-red-500 decoration-2" data-id="element-149">
              $65 USD
            </span>
          </p>
          <p className="mt-1 font-display text-5xl text-white" data-id="element-150">
            $25 <span className="text-2xl text-orange-400" data-id="element-151">USD</span>
          </p>
          <p className="mt-1 text-xs font-semibold text-orange-400" data-id="element-152">
            Save $40 today · One-time payment
          </p>
        </div>

        {/* Buy button */}
        <motion.button onClick={goToCheckout} whileHover={{
        scale: 1.03
      }} whileTap={{
        scale: 0.97
      }} animate={{
        boxShadow: ['0 0 0 0 rgba(249,115,22,0.5)', '0 0 0 16px rgba(249,115,22,0)']
      }} transition={{
        boxShadow: {
          duration: 1.6,
          repeat: Infinity
        }
      }} className="mt-5 w-full rounded-xl bg-orange-500 px-6 py-4 text-base font-extrabold uppercase tracking-wide text-black transition-colors hover:bg-orange-400" data-id="element-153">
          I Want to Improve My Practices
        </motion.button>

        {/* Trust badges */}
        <div className="mt-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[11px] text-neutral-400" data-id="element-154">
          <span className="flex items-center gap-1" data-id="element-155">
            <FileTextIcon className="h-3.5 w-3.5 text-orange-400" data-id="element-156" /> 100% PDF
          </span>
          <span className="flex items-center gap-1" data-id="element-157">
            <ZapIcon className="h-3.5 w-3.5 text-orange-400" data-id="element-158" /> Instant delivery
          </span>
          <span className="flex items-center gap-1" data-id="element-159">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-orange-400" data-id="element-160" /> Secure
            payment
          </span>
        </div>
      </div>
    </section>;
}